import { DIMENSION } from '@adtrackify/at-tracking-event-types';

import {
  ATTRIBUTION_TAB_HIERARCHY,
  DIMENSION_DISPLAY_LABELS,
} from '../constants/attribution-constants';
import type {
  DimensionFilter,
  DimensionFilterGroup,
} from '../types/attribution-types';

export function getDimensionDisplayLabel(dimension: string): string {
  return DIMENSION_DISPLAY_LABELS[dimension as DIMENSION] ?? dimension;
}
export function normalizeAttributionDimension(dimension: DIMENSION): DIMENSION {
  if (dimension === DIMENSION.UTM_ADSET) {
    return DIMENSION.UTM_TERM;
  }
  if (dimension === DIMENSION.UTM_AD) {
    return DIMENSION.UTM_CONTENT;
  }
  if (dimension === DIMENSION.AD_SOURCE) {
    return DIMENSION.UTM_SOURCE;
  }
  return dimension;
}
export function toDimensionFilterGroups(
  flat: DimensionFilter[]
): DimensionFilterGroup[] {
  if (flat.length === 0) {
    return [];
  }

  const byDimension = new Map<DIMENSION, DimensionFilter[]>();
  for (const filter of flat) {
    const existing = byDimension.get(filter.dimension);
    if (existing) {
      existing.push(filter);
    } else {
      byDimension.set(filter.dimension, [filter]);
    }
  }

  const groups: DimensionFilterGroup[] = [];
  for (const dim of ATTRIBUTION_TAB_HIERARCHY) {
    const group = byDimension.get(dim);
    if (group && group.length > 0) {
      groups.push(group);
      byDimension.delete(dim);
    }
  }

  for (const group of byDimension.values()) {
    if (group.length > 0) {
      groups.push(group);
    }
  }

  return groups;
}
